import { defineStore } from 'pinia'
import { actions, getters, state } from './ext/items.js'
import axios from 'axios'


export const useOrganizationPublicStore = defineStore('organizationPublic', {
  id: 'organizationPublic',
  state: () => ({
    items: [],
    api: '/api/v1/organizations-public'
  }),
  getters: {
    ...getters
  },
  actions: {
    ...actions
  }
})
